import { defineMessages } from 'react-intl';

export default defineMessages({
  pending: 'Pending',
  confirmed: 'Confirmed',
  failed: 'Failed',
  error: 'Error',
});
